import { normalize } from 'normalizr';
import { query, mutation } from '@/dex-shared/helpers/graphql';
import { examMode } from '@/dex-shared/helpers/normalizr_schema';

export default {
  async PULL_EXAM_MODES(
    { commit }: any,
    payload: undefined | { page: number; size: number },
  ) {
    let size = null;
    let page = null;
    if (payload) {
      page = payload.page;
      size = payload.size;
    }
    const response = await query(
      `query getAllExamModesDexAdmin($offset: Int, $size: Int) {
      allExamModes(
        first: $size
        offset: $offset
      ) {
        nodes {
          id
          name
        }
      }
    }`,
      {
        size,
        offset: page * size,
      },
    );
    const normalizedResponse = normalize(response.data.allExamModes.nodes, [
      examMode,
    ]);
    commit('CLEAN_STATE', 'exam_modes');
    commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
  },
  async PULL_EXAM_MODE({ commit }: any, examModeId: number) {
    const response = await query(
      `query getExamModeDexAdmin($examModeId: Int!) {
        examModeById(id: $examModeId) {
          id
          name
          description
        }
      }`,
      {
        examModeId,
      },
    );
    commit('UPDATE_ENTITY', {
      entity: 'exam_modes',
      data: response.data.examModeById,
    });
  },
  async CREATE_EXAM_MODE({ commit }: any, name: string) {
    const response = await mutation(
      `mutation dexAdminCreateExamMode($name: String!) {
        createExamMode(input: {
          examMode: {name: $name}
        }) {
          examMode {
            id
            name
          }
        }
      }`,
      {
        name,
      },
    );
    commit('UPDATE_ENTITY', {
      entity: 'exam_modes',
      data: response.data.createExamMode.examMode,
    });
    return response.data.createExamMode.examMode.id;
  },
  async PUSH_EXAM_MODE_BY_ID({ getters }: any, examModeId: number) {
    const examMode = getters.examModeById(examModeId);
    await mutation(
      `
      mutation dexAdminUpdateExamModeById($id: Int!, $name: String!, $description: String) {
        updateExamModeById(input: {
          id: $id
          examModePatch: {
            name: $name
            description: $description
          }
        }) {
          examMode {
            id
          }
        }
      } 
    `,
      examMode.raw(),
    );
  },
  async DELETE_EXAM_MODE({ commit }: any, examModeId: number) {
    await mutation(
      `mutation dexAdminDeleteExamModeById($examModeId: Int!) {
      deleteExamModeById(input: {
        id: $examModeId
      }) {
        examMode {
          id
        }
      }
    }`,
      {
        examModeId,
      },
    );
    commit('DELETE_ENTITY', {
      entity: 'exam_modes',
      id: examModeId,
    });
  },
};
